import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Loading, Button, Layout, } from '@folio/stripes/components';
/**
 * Shared loading/error/404 state for detail panes.
 * Returns null when data is loaded successfully (caller should render content).
 */
var DetailLoadingState = function (_a) {
    var _b;
    var isLoading = _a.isLoading, isError = _a.isError, error = _a.error, onClose = _a.onClose, onRetry = _a.onRetry, i18nPrefix = _a.i18nPrefix;
    if (isLoading) {
        return React.createElement(Loading, null);
    }
    if (isError) {
        var is404 = error && typeof error === 'object' && 'response' in error
            && ((_b = error.response) === null || _b === void 0 ? void 0 : _b.status) === 404;
        if (is404) {
            return (React.createElement(Layout, { className: "display-flex flex-direction-column centerContent padding-all-gutter" },
                React.createElement("p", null,
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.".concat(i18nPrefix, ".notFound") })),
                React.createElement("p", { style: { color: '#666' } },
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.".concat(i18nPrefix, ".notFoundDescription") })),
                React.createElement(Button, { onClick: onClose },
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.".concat(i18nPrefix, ".close") }))));
        }
        return (React.createElement(Layout, { className: "display-flex flex-direction-column centerContent padding-all-gutter" },
            React.createElement("p", null,
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.".concat(i18nPrefix, ".loadError") })),
            React.createElement(Button, { onClick: onRetry, style: { marginTop: '8px' } },
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.".concat(i18nPrefix, ".retry") })),
            React.createElement(Button, { onClick: onClose, style: { marginTop: '8px' } },
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.".concat(i18nPrefix, ".close") }))));
    }
    return null;
};
export default DetailLoadingState;
